import React, { useEffect, useState } from 'react';
import { Descriptions, Spin, message } from 'antd';
import axios from '../../../config/axiosInstance';

const InfoTab = ({ participantId, host, participantTypes, participantStates }) => {
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchParticipantDetails = async () => {
        try {
            const tokenRes = await axios.get(`/regasus/token?host=${host}`);
            const token = tokenRes.data.access_token;

            if (!token) return message.error('No token received');

            const res = await axios.post('/regasus/get-participant-by-id', {
                token,
                host,
                participantId,
            });

            setDetails(res.data?.participant);
        } catch (err) {
            console.error(err);
            message.error('Error loading participant info');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchParticipantDetails();
    }, [participantId, host]);

    if (loading) return <Spin />;
    if (!details) return null;

    const getTypeName = (id) => {
        if (!participantTypes) return id;
        return participantTypes.find(t => t.id === id)?.name?.[0]?.value || id;
    };

    const getStateName = (id) => {
        if (!participantStates) return id;
        return participantStates.find(s => s.id === id)?.name?.[0]?.value || id;
    };

    return (
        <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Name">{details.name}</Descriptions.Item>
            <Descriptions.Item label="Email">
                {details.communication?.email1 ? (
                    <a href={`mailto:${details.communication.email1}`}>{details.communication.email1}</a>
                ) : '—'}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
                {details.communication?.phone1 ? (
                    <a href={`tel:${details.communication.phone1}`}>{details.communication.phone1}</a>
                ) : '—'}
            </Descriptions.Item>
            <Descriptions.Item label="Organisation">{details.address1?.organisation || '—'}</Descriptions.Item>
            <Descriptions.Item label="Street">{details.address1?.street || '—'}</Descriptions.Item>
            <Descriptions.Item label="City">{details.address1?.city || '—'}</Descriptions.Item>
            <Descriptions.Item label="ZIP">{details.address1?.zip || '—'}</Descriptions.Item>
            <Descriptions.Item label="Country">{details.address1?.country || '—'}</Descriptions.Item>
            <Descriptions.Item label="Participant Type">{getTypeName(details.participantTypeID)}</Descriptions.Item>
            <Descriptions.Item label="Participant State">{getStateName(details.participantStateID)}</Descriptions.Item>
            <Descriptions.Item label="VIP">{details.vip ? 'Yes' : 'No'}</Descriptions.Item>
            <Descriptions.Item label="Register Date">{details.registerDate}</Descriptions.Item>
        </Descriptions>
    );
};

export default InfoTab;